import React from 'react';
import { motion } from 'framer-motion';
import { BadgeCheck, Clock, HeartHandshake, ShieldCheck } from 'lucide-react';
import { IMAGES } from './data';
const POINTS = [{
  icon: <BadgeCheck className="h-5 w-5" data-id="element-166" data-mp="1lpcu5wqnv45y" />,
  title: 'Quality craftsmanship',
  text: 'Every install is built to a professional standard and finished with care.'
}, {
  icon: <ShieldCheck className="h-5 w-5" data-id="element-167" data-mp="1gscsdy0ugnkn" />,
  title: 'Licensed & reliable',
  text: 'A crew you can trust on your property, from small yards to large commercial jobs.'
}, {
  icon: <Clock className="h-5 w-5" data-id="element-168" data-mp="1qo7ex486v2sp" />,
  title: 'On time, on budget',
  text: 'Clear timelines and honest pricing — no surprises when the work is done.'
}, {
  icon: <HeartHandshake className="h-5 w-5" data-id="element-169" data-mp="1zhstamgfyi1l" />,
  title: 'We keep service first',
  text: 'We exist to keep service at the center of everything we build for you.'
}];
const STATS = [{
  value: '500+',
  label: 'Projects completed'
}, {
  value: '10+',
  label: 'Years of experience'
}, {
  value: '5.0',
  label: 'Average rating'
}];
export function WhyUs() {
  return <section id="why-us" className="w-full bg-secondary py-20 sm:py-24" data-id="element-170" data-mp="322ake6yn21pi">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-171" data-mp="324ohsmgsjq08">
        <div className="grid grid-cols-1 items-center gap-12 lg:grid-cols-2" data-id="element-172" data-mp="363e2z182mbuf">
          <motion.div initial={{
          opacity: 0,
          x: -24
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.5
        }} className="relative" data-id="element-173" data-mp="3b3iianx8t0j2">
            <img src={IMAGES.pergola} alt="Backyard with green turf, pavers, and a modern shade pergola" className="aspect-[4/3] w-full rounded-3xl object-cover shadow-xl" data-id="element-174" data-mp="3kz3eu6jjl8lf" />
            <div className="absolute -bottom-6 left-1/2 flex w-[88%] -translate-x-1/2 justify-around rounded-2xl border border-border bg-card px-4 py-5 shadow-lg" data-id="element-175" data-mp="2nytq27io6ac">
              {STATS.map(stat => <div key={stat.label} className="text-center" data-id="element-176" data-mp="23p53g0k8ahus">
                  <div className="font-heading text-2xl font-bold text-brand-red" data-id="element-177" data-mp="23nbtocebjhik">
                    {stat.value}
                  </div>
                  <div className="mt-1 text-xs text-muted-foreground" data-id="element-178" data-mp="2dfrc1atj283z">{stat.label}</div>
                </div>)}
            </div>
          </motion.div>

          <div className="lg:pl-6" data-id="element-179" data-mp="28myaevtcvfw4">
            <span className="text-sm font-semibold uppercase tracking-wider text-brand-red" data-id="element-180" data-mp="2mfef011wnlz5">
              Why Plote
            </span>
            <h2 className="mt-3 font-heading text-3xl font-bold tracking-tight text-brand-ink sm:text-4xl" data-id="element-181" data-mp="2ieb1hl7by213">
              Arizona's outdoor experts, dedicated to the details
            </h2>
            <p className="mt-4 text-lg text-muted-foreground" data-id="element-182" data-mp="2rfsc4o1yxbie">
              We treat every yard like it's our own. From the first walkthrough to the
              final clean-up, we're focused on results you'll be proud of for years.
            </p>

            <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2" data-id="element-183" data-mp="38ouudaj8fb80">
              {POINTS.map(point => <div key={point.title} className="flex gap-4" data-id="element-184" data-mp="3dnxtyfgg0p8l">
                  <div className="inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-brand-navy text-white" data-id="element-185" data-mp="2yyrv4slip118">
                    {point.icon}
                  </div>
                  <div data-id="element-186" data-mp="33vs4bcdnyjwk">
                    <h3 className="font-heading font-semibold text-brand-ink" data-id="element-187" data-mp="2pyd5xi5fn1sg">
                      {point.title}
                    </h3>
                    <p className="mt-1 text-sm leading-relaxed text-muted-foreground" data-id="element-188" data-mp="2uxy6fx093i7a">
                      {point.text}
                    </p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}